import script from "./add-data.vue?vue&type=script&setup=true&lang=js"
export * from "./add-data.vue?vue&type=script&setup=true&lang=js"

import "./add-data.vue?vue&type=style&index=0&id=4c4c40b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c4c40b7"]])

export default __exports__